<template>
    <div class="w-full">
      <vx-card id="bulkUploadCourseCard" title="">
        <div class="vx-row">
          <div class="vx-col">
            <div class="flex flex-wrap items-center justify-center">
              <div class="vs-con-loading__container">
                <v-uploader v-show="!isBulkAddHidden && !bulkCsvFileUrl" @done="csvSuccessUpload" ref="bulkUpload" file-type-exts="csv" button-text="Upload .csv file" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
              </div>
              <vs-button v-show="bulkCsvFileUrl" ref="confirmBulkButton" color="success" size="small" class="mb-4 mr-3" @click="confirmBulkCourseUpload">Add Courses</vs-button>
              <vs-button v-show="!isBulkAddHidden && canCancel" color="warning" size="small" class="mb-4 ml-3" @click="cancelBulkAdd">Cancel</vs-button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-button ref="processBulkButton" color="warning" size="small" class="mb-4 mr-3" @click="process">Process</vs-button>
              <vs-button type="border" size="small" class="mb-4 ml-3" @click="downloadTemplate">Get Template</vs-button>
            </div>
          </div>
        </div>
        <vs-table stripe ref="bulkCoursesTable" class="vs-con-loading__container" single pagination :max-items="itemsPerPage" search :data="bulkCourses">

          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ bulkCourses.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : bulkCourses.length }} of {{ bulkCourses.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=200">
                  <span>200</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=300">
                  <span>300</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=500">
                  <span>500</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=1000">
                  <span>1000</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
  
          <template slot="thead">
            <vs-th sort-key="name">Module</vs-th>
            <vs-th sort-key="contactPersonName">Task Id</vs-th>
            <vs-th sort-key="contactMobile">Video Name</vs-th>
            <vs-th sort-key="contactEmail">Nav Option Text</vs-th>
            <vs-th sort-key="totalStudents">Nav Option Task</vs-th>
            <vs-th sort-key="isStartTask">Is Start Task</vs-th>
            <vs-th sort-key="processingException">Processing Exception</vs-th>
            <vs-th sort-key="createDt">Create Date</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="bulkCourse" :state="bulkCourse.processingException ? 'danger' : bulkCourse.processed? 'success' : 'warning'" :key="indextr" v-for="(bulkCourse, indextr) in data">

              <vs-td :data="data[indextr].module">
                {{ bulkCourse.module ? bulkCourse.module : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].taskId">
                {{ bulkCourse.taskId }}
              </vs-td>

              <vs-td :data="data[indextr].videoName">
                {{ bulkCourse.videoName ? bulkCourse.videoName : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].textNavigationOptionText">
                {{ bulkCourse.textNavigationOptionText ? bulkCourse.textNavigationOptionText : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].textNavigationOptionTaskId">
                {{ bulkCourse.textNavigationOptionTaskId ? bulkCourse.textNavigationOptionTaskId : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].isStartTask">
                {{ bulkCourse.isStartTask ? bulkCourse.isStartTask == "TRUE" ? "Yes" : "No" : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].processingException">
                {{ bulkCourse.processingException ? bulkCourse.processingException : "No exception" }}
              </vs-td>

              <vs-td :data="data[indextr].createDt">
                {{ bulkCourse.createDt.replace("T", " ").split('.')[0] }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>

  export default {
    data() {
      return {
        selected: [],
        isBulkAddHidden: false,
        bulkCsvFileUrl: "",
        canCancel: false,
        isLoading: false,
        bulkCourses: [],
        itemsPerPage: 300,
        isMounted: false,
        wasSidebarOpen: false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.bulkCoursesTable.currentx;
        }
        return 0;
      }
    },
    methods: {
      csvSuccessUpload(data) {
        this.isLoading = false;
        this.canCancel = true;
        this.bulkCsvFileUrl = data[0].url;
      },
      confirmBulkCourseUpload() {
        var self = this;
        self.canCancel = false;
        self.showLoadingOnElement('confirmBulkButton', 0.35, 'material');

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: response.data,
            time: 7000,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
          self.loadBulkCourseData();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.confirmBulkButton.$el);
          self.cancelBulkAdd();
        };
        
        self.$ajaxGet(self, "BulkCourseUpload/Upload?fileUrl=" + self.bulkCsvFileUrl, onSuccess, onFinally);

      },
      process() {
        var self = this;
        self.showLoadingOnElement('processBulkButton', 0.35, 'material');

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: response.data,
            time: 7000,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
          self.loadBulkCourseData();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.processBulkButton.$el);
        };
        
        self.$ajaxGet(self, "BulkCourseUpload/process", onSuccess, onFinally);

      },
      cancelBulkAdd() {
        this.isLoading = false;
        this.isBulkAddHidden = false;
        this.bulkCsvFileUrl = "";
        this.canCancel = false;
        this.$vs.loading.close(this.$refs.bulkUpload.$el);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      loadBulkCourseData() {
        const self = this;
        self.showLoadingOnElement('bulkCoursesTable', 1, 'corners')

        var onSuccess = function(response) {
          self.bulkCourses = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.bulkCoursesTable.$el);
        };

        self.$ajaxGet(self, "BulkCourseUpload/GetBulkUplaodData", onSuccess, onFinally);
      },
      
      downloadTemplate(){
        var self = this;
        window.open("https://lateralscaffolding.blob.core.windows.net/studentbulk/Template_bulkUpload_Videos1.xlsx");
      },
      addUploaderClickEvents() {
        var self = this;

        self.$refs.bulkUpload.$el.addEventListener("click", function(){
          if(!self.isLoading) {
            self.isLoading = true;
            self.showLoadingOnElement("bulkUpload", 0.50, "material");
          }else{
            self.isLoading = false;
            self.$vs.loading.close(self.$refs.bulkUpload.$el);
          }
        });
      },
      showLoadingOnTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.bulkCoursesTable.$el,
          scale: 1
        });
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    },
    mounted() {
      var self = this;
      self.wasSidebarOpen = this.$store.state.reduceButton;
      self.isMounted = true;
      self.addUploaderClickEvents();
      self.showLoadingOnTable();
      self.loadBulkCourseData();
      // document.getElementsByClassName("input-search")[0].innerText = "";
      // self.$refs.bulkCoursesTable.searchx = "";
      self.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    },
    beforeDestroy() {
      if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
    }
  }

</script>
<style lang="scss">
  div.btn.singleFileUpload.uploader-button {
    padding: 10px !important;
    border-radius: 30px !important;
    background-color: rgb(40, 199, 111) !important;
    color: rgb(255, 255, 255) !important;
    font-size: 15px !important;
    font-variant: small-caps !important;
    font-weight: 600 !important;
  }

  div.v-uploader {
    .vs-con-loading__container .con-vs-loading {
      top: 38% !important;
    }
  }
</style>
